import { MatTableDataSource, MatTable } from '@angular/material/table';
import { OnInit, Component, Inject, ViewChild, LOCALE_ID } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CProduct } from 'src/app/classes/decorticage/info-product';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import {formatNumber} from '@angular/common';

type dialogProductDisplayType = 'AddProdInAnalysis'|'SelectProdMesh';

interface LoadedProduct {
  ProductCode: string;
  Label: string;
  Family: string;
  Unit1: string;
  Unit2: string;
  ProductU1Weight: number;
  U1ToU2: number;
}

@Component({
    templateUrl: './dialogProductInput.html',
    styleUrls: ['./dialogProductInput.css']
})
// tslint:disable-next-line:component-class-suffix
export class DialogProductInput implements OnInit {

    @ViewChild('tableProduct', { static: true }) matTableProduct!: MatTable<CProduct>;        // Afficher dans la table html

    /*
    Saisie de produits
    */
    readonly mModalType: dialogProductDisplayType;
    search: string = '';
    selectedImage: string;

    HTML_PRODUCTINPUT_COL = {
        ProductCode: 'ProductCode',
        Label: 'Label',
        Unit: 'Unit',
        Image: 'Image',
        Qty: 'Qty',
        Add: 'Add',
        Weight: 'Weight'
    };

    dataSource: MatTableDataSource<CProduct>; // Correspond au décorticage

    public static async openDialog(matDialog: MatDialog, modalType: dialogProductDisplayType): Promise<CProduct[]|false> {
        const dialogParamRef = matDialog.open(DialogProductInput,
            {
                height: '90%',
                width: '85%',
                data: modalType
            }
        );
        return dialogParamRef.afterClosed().toPromise();
    }

    constructor(
      private http: HttpClient,
      private sanitizer: DomSanitizer,
      public mDialogRef: MatDialogRef<DialogProductInput>,
      @Inject(MAT_DIALOG_DATA) modalType: dialogProductDisplayType,
      @Inject(LOCALE_ID) public locale: string
    ) {
      this.dataSource = new MatTableDataSource<CProduct>([]);
      this.mModalType = modalType;
      this.selectedImage = '';
    }

    ngOnInit(): void {
      //Chargement de la liste des produits
      this.loadListProdut().then(() => this.loadImageproduct(this.dataSource.data));
    }

    private getAddedProducts(): CProduct[] {
      const result: CProduct[] = [];
      this.dataSource.data.forEach(product => {
        if (product.mQty > 0) {
          result.push(product);
        }
    });
    return result;
  }

  onDialogBtnClick(result: 'OK'|'CANCEL') {
    switch (result) {
      case 'OK':
        this.closeDialog(this.getAddedProducts()); // On retourne les lignes en résultat
        break;
      case 'CANCEL':
      default:
        this.closeDialog(false);
        break;
    }
  }

  /**Ferme le dialog avec les produits ou false si annuler */
  private closeDialog(closeResult: CProduct[]|false) {
    this.mDialogRef.close(closeResult);
  }

  async loadListProdut() {
    try {
      // Clear du tableau
      this.dataSource.data = [];

      // Chargement des données depuis armaserv
      const loadedProducts: LoadedProduct[] = (await ArmaServConnection.aGET(this.http, 'GetLoadProducts', [])).result[0];
      loadedProducts.forEach(product => {
        const prod: CProduct = new CProduct();
        prod.mLabel = product.Label;
        prod.mProductCode = product.ProductCode;
        prod.mUnit1 = product.Unit1;
        prod.mUnit2 = product.Unit2;
        prod.mU1Weight = product.ProductU1Weight;
        prod.mU1ToU2 = product.U1ToU2;
        prod.mQty = 0;
        this.dataSource.data.push(prod);
      });
    } finally {
      this.matTableProduct.renderRows(); // Affichage des données dans le tableau
      this.dataSource._updateChangeSubscription();
    }
  }

  loadImageproduct(products: CProduct[]) {
    products.forEach(product => product.loadImageproduct(this.http, this.sanitizer));
  }

  get displayedColumns(): string[] {
    const result: string[] = [];
    result.push(this.HTML_PRODUCTINPUT_COL.Image);
    result.push(this.HTML_PRODUCTINPUT_COL.ProductCode);
    result.push(this.HTML_PRODUCTINPUT_COL.Label);
    result.push(this.HTML_PRODUCTINPUT_COL.Qty);
    result.push(this.HTML_PRODUCTINPUT_COL.Unit);
    result.push(this.HTML_PRODUCTINPUT_COL.Weight);
    result.push(this.HTML_PRODUCTINPUT_COL.Add);
    return result;
  }

  applyFilter() {
    this.dataSource.filter = this.search.trim().toLowerCase();
  }

  onProdBtnClick(product: CProduct) {
    switch (this.mModalType) {
      case 'AddProdInAnalysis':
        product.mQty++;
        break;
      case 'SelectProdMesh':
        this.closeDialog([product]);
        break;
    }
  }

  onTableLineDblClick(row: CProduct) {
    if (this.mModalType == 'SelectProdMesh') {
      this.closeDialog([row]);
    }
  }

  private getUnitList(product: CProduct): string[] {
    const result: string[] = [];
    result.push(product.mUnit1);
    if (product.mUnit2 != '') {
      result.push(product.mUnit2);
    }
    return result;
  }

  onUnitChanged(product: CProduct, newUnit: string) {
    product.mUnitUsed = newUnit;
  }

  private getSelectedUnit(product: CProduct): string {
    if (product.mUnitUsed == '') {
      return product.mUnit1;
    }
    return product.mUnitUsed;
  }

  private getProductWeight(product: CProduct): string {
    const weight: number = product.totalWeight;
    return weight == 0 ? '' : formatNumber(weight, this.locale, '1.0-2') + ' kg';
  }

}
